import type { PostgrestError } from '@supabase/supabase-js';

/** Matches typical PostgREST `max_rows`; single-request `.limit()` above this is still capped. */
export const SUPABASE_PAGE_SIZE = 1000;

/**
 * Fetches all rows for a query by paging with `.range(from, to)` until a partial page or empty result.
 * Accepts Supabase `PostgrestFilterBuilder` (thenable), not only native Promises.
 */
export async function fetchAllPaginated<T>(
  buildQuery: (
    from: number,
    to: number
  ) => PromiseLike<{ data: T[] | null; error: PostgrestError | null }>,
  options?: { maxRows?: number }
): Promise<T[]> {
  const maxRows = options?.maxRows ?? 500_000;
  const rows: T[] = [];
  let offset = 0;

  while (rows.length < maxRows) {
    const to = offset + SUPABASE_PAGE_SIZE - 1;
    const { data, error } = await buildQuery(offset, to);
    if (error) throw error;
    if (!data?.length) break;
    rows.push(...data);
    if (data.length < SUPABASE_PAGE_SIZE) break;
    offset += SUPABASE_PAGE_SIZE;
  }

  return rows;
}
